import { Grow } from '@mui/material';
import { VariantType, useSnackbar as usNotistackSnackbar } from 'notistack';
import { useCallback } from 'react';

export const useSnackbar = () => {
  const { enqueueSnackbar } = usNotistackSnackbar();
  return useCallback(
    (variant: VariantType, message: string, vertical?: 'top' | 'bottom') => {
      enqueueSnackbar(message, {
        variant,
        hideIconVariant: variant === 'success',
        anchorOrigin: {
          vertical: vertical ?? 'bottom',
          horizontal: 'center',
        },
        TransitionComponent: Grow,
      });
    },
    [enqueueSnackbar]
  );
};
